module.exports = __webpack_public_path__ + "img/req1uest.2a90869b.png";